"use client";
import React, { CSSProperties } from "react";
import useEmblaCarousel from "embla-carousel-react";
import { ChevronLeft, ChevronRight } from "lucide-react";
import HorizontalShortcutItemComponent from "./horizontal-shortcut-item";

const HorizontalShortcutCarousel = ({
    shortcutItems,
    priorityImage,
    session,
    loc,
}: {
    shortcutItems: any;
    priorityImage?: boolean;
    session?: any;
    loc: string;
}) => {
    const [emblaRef, emblaApi] = useEmblaCarousel({ loop: false, dragFree: true });
    const scrollNext = () => {
        if (emblaApi) emblaApi.scrollNext();
    };

    const scrollPrev = () => {
        if (emblaApi) emblaApi.scrollPrev();
    };

    return (
        <div className="embla">
            <div className="embla" ref={emblaRef}>
                <div className="embla__container">
                {shortcutItems.map((item: any, index: number) => (
                    <div className="pl-4" key={index}>
                    <HorizontalShortcutItemComponent
                        key={index}
                        item={item}
                    />
                    </div>
                ))}
                    <div className="lg:px-10 md:px-5 px-2" />
                </div>
            </div>
            <div className="w-full flex justify-between items-center mt-10 lg:px-20 md:px-10 px-2 ">
                <div className="w-1/3"> </div>
                <div className="flex w-1/3 justify-end ">
                    {/* ปุ่ม Previous และ Next */}
                    <button
                        className="embla__button embla__button--prev inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-[16px] font-normal border border-input bg-transparent hover:border-c2 hover:text-c2 active:bg-c2 active:text-c2-foreground h-8 w-8 rounded-full max-md:hidden relative transform left-0 top-0 translate-y-0 mx-1"
                        onClick={scrollPrev}>
                        <ChevronLeft className="h-5 w-5" />
                    </button>
                    <button
                        className="embla__button embla__button--next inline-flex items-center justify-center whitespace-nowrap ring-offset-background transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 text-[16px] font-normal border border-input bg-transparent hover:border-c2 hover:text-c2 active:bg-c2 active:text-c2-foreground h-8 w-8 rounded-full -right-12 max-md:hidden relative transform left-0 top-0 translate-y-0 mx-1"
                        onClick={scrollNext}>
                        <ChevronRight className="h-5 w-5" />
                    </button>
                </div>
            </div>
        </div>
    );
};

export default HorizontalShortcutCarousel;